import {ChangeDetectionStrategy, Component, input, InputSignal} from '@angular/core';

import {TranslateModule} from '@ngx-translate/core';

/**
 * customizable css variables: --item-background,
 * @example
 * ```html
 * <dc-instruction-list-view
 * 	[style.--item-background]="'rgba(33,55,105,0.07)'"
 * 		[instructionListTitle]="instructionListTitle"
 * 			[instructionList]="instructionList"
 * 			/>
 * 			```
 */
@Component({
	selector: 'dc-instruction-list-view',
	imports: [TranslateModule],
	templateUrl: './instruction-list-view.component.html',
	styleUrl: './instruction-list-view.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstructionListViewComponent {
	/* ------------------------------------------  Types and Constants ------------------------------------------ */
	/* ------------------------------------------ PROVIDERS / SERVICES ------------------------------------------ */

	/* ------------------------------------------------  Inputs ------------------------------------------------ */
	instructionListTitle: InputSignal<string> = input.required<string>();
	instructionList: InputSignal<string[]> = input.required<string[]>();
	/* ------------------------------------------------  Outputs ------------------------------------------------ */

	/* ------------------------------------------------  Signals ------------------------------------------------ */

	/* -------------------------------------------------- Data -------------------------------------------------- */

	/* ------------------------------------------------  Constructor ------------------------------------------------ */
	constructor() {}

	/* ----------------------------------------------- Lifecycle Hooks ----------------------------------------------- */

	/* ------------------------------------------------  Methods ------------------------------------------------ */
}
